import { useState, useEffect } from 'react';

import './FilterComponent.css';

import { BeListeProps, BeData, BeRow, ListHeader, ClickableButton, FilterButton, ActivableButton, FilterComponentProps } from '../interfaces';

function FilterComponent({ label, loadList, setFilterTextRef }:FilterComponentProps) {
  const [filterText, setFilterText] = useState<string>('');
  const [filterOn, setFilterOn] = useState<boolean>(true);

  function handleInputChange(event:React.ChangeEvent<HTMLInputElement>) {
    setFilterText(event.currentTarget.value);
  }

  function handleSubmit(event:React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (filterOn) {
      setFilterTextRef(filterText);
      setFilterOn(false);
    } else {
      setFilterTextRef('');
      setFilterOn(true);
    }

    loadList();
  }

  return (
    <>
      <form aria-label="filter" className="filter-component" onSubmit={handleSubmit}>
        <label>Liste der {label} filtern</label>
        <div className="filter-input">
          <input 
            type="text" 
            value={filterText} 
            aria-label="filterbegriff eingeben"
            disabled={filterOn === false}
            onChange={handleInputChange} 
          />
          <button 
            className={filterOn ? 'filter-on' : 'filter-off'}
            type="submit" 
            aria-label="filter starten"
          >
            { /* <img src={filter} alt={alt} /> */ }
          </button>
        </div>
      </form>
      { /* <p className="filter-message">{hits ? hits + hitsMessage : null}</p> */ }
    </>
  );
}

export default FilterComponent;
